import emptySliceApi from '../../../../shared/store/emptyApiSlice';
import { PrimaryContactApiModel } from '../../../../shared/models/DealModel';

export const apiSlice = emptySliceApi.injectEndpoints({
  endpoints: (builder) => ({
    updatePointOfContact: builder.mutation<
      void,
      { accountId: string; dealId: string; payload: PrimaryContactApiModel }
    >({
      query: ({ accountId, dealId, payload }) => ({
        url: `v4/accounts/${accountId}/deals/${dealId}/contacts/primary`,
        method: 'PUT',
        body: payload,
      }),
      invalidatesTags: ['Deal'],
    }),
  }),
});

export const { useUpdatePointOfContactMutation } = apiSlice;
